import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceDirectCost, ServiceDirectCostInput} from './service-direct-cost.model';

export const loadServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Load ServiceDirectCosts',
  props<{ serviceDirectCosts: ServiceDirectCost[] }>()
);

export const addServiceDirectCost = createAction(
  '[ServiceDirectCost/API] Add ServiceDirectCost',
  props<{ serviceDirectCost: ServiceDirectCost }>()
);

export const upsertServiceDirectCost = createAction(
  '[ServiceDirectCost/API] Upsert ServiceDirectCost',
  props<{ serviceDirectCost: ServiceDirectCost }>()
);

export const addServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Add ServiceDirectCosts',
  props<{ serviceDirectCosts: ServiceDirectCost[] }>()
);

export const upsertServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Upsert ServiceDirectCosts',
  props<{ serviceDirectCosts: ServiceDirectCost[] }>()
);

export const updateServiceDirectCost = createAction(
  '[ServiceDirectCost/API] Update ServiceDirectCost',
  props<{ serviceDirectCost: Update<ServiceDirectCost> }>()
);

export const updateServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Update ServiceDirectCosts',
  props<{ serviceDirectCosts: Update<ServiceDirectCost>[] }>()
);

export const deleteServiceDirectCost = createAction(
  '[ServiceDirectCost/API] Delete ServiceDirectCost',
  props<{ id: string }>()
);

export const deleteServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Delete ServiceDirectCosts',
  props<{ ids: string[] }>()
);

export const clearServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] Clear ServiceDirectCosts'
);

// CUSTOM
export const createServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] create ServiceDirectCosts',
  props<{ input: ServiceDirectCostInput }>()
);


export const editServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] edit ServiceDirectCosts',
  props<{ input: ServiceDirectCostInput }>()
);


export const removeServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] remove ServiceDirectCosts',
  props<{ costUniqueId: string; id: string }>()
);


export const getServiceDirectCosts = createAction(
  '[ServiceDirectCost/API] get all ServiceDirectCosts',
  props<{ billingUniqueId: string }>()
);

// Modified
export const citizenGetInstitutionServiceDirectCostSchemes = createAction(
  '[ServiceDirectCost/API] citizen get institution ServiceDirectCosts',
  props<{ billingUniqueId: string }>()
);
